var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_59_1",
    "data-name": "Component 59 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12701",
    "data-name": "Path 12701",
    d: "M25.453,15.253A13.335,13.335,0,0,0,13.5,7.5,13.335,13.335,0,0,0,1.548,15.253a.665.665,0,0,0,0,.495A13.335,13.335,0,0,0,13.5,23.5a13.335,13.335,0,0,0,11.952-7.753.665.665,0,0,0,0-.495ZM13.5,22.045A11.908,11.908,0,0,1,3.156,15.5,11.908,11.908,0,0,1,13.5,8.955,11.908,11.908,0,0,1,23.845,15.5,11.908,11.908,0,0,1,13.5,22.045Z",
    transform: "translate(-1.501 -7.5)",
    fill: "#00c22d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12702",
    "data-name": "Path 12702",
    d: "M19,15a4,4,0,1,0,4,4A4,4,0,0,0,19,15Zm0,6.667A2.667,2.667,0,1,1,21.667,19,2.667,2.667,0,0,1,19,21.667Z",
    transform: "translate(-7 -11)",
    fill: "#00c22d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGreen);
export default __webpack_public_path__ + "static/media/eyeGreen.9cd8fa06879d18b905d2a1dfe1b5f68e.svg";
export { ForwardRef as ReactComponent };